var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcImmersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 35.179,
    height: 35.179,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_immersion",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(336.244 222.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185-2",
    "data-name": "Group 185",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21776",
    "data-name": "Path 21776",
    d: "M32.373,16.429a15.823,15.823,0,0,1-1.937,7.61l-1.609-1.326-.318-5.464-7.1,11.717-2.327-1.78-.591-4.722-5.16-2.146-2.464-1.463-.072-3.5,8.105.154,3.872,2.58,4.863-3.243-2.074-2.3-2.618,2.095-.858-.3.574-2.631L17.741,9.489,17.56,12.28l-4.815.072L12.482,9.6l3.981-.909,7.5-.267L22.863,4.3,20.2,3.321l1.169-2.043a15.964,15.964,0,0,1,11,15.151M4.886,5.456l.731.865-.6,3.971L1.281,11.47A15.933,15.933,0,0,1,4.886,5.456m9.076,26.7a18.869,18.869,0,0,1,3.448-.543,30.366,30.366,0,0,1,3.711.048,15.39,15.39,0,0,1-7.159.5m8.864-1.138a28.61,28.61,0,0,0-5.457-.226,21.85,21.85,0,0,0-5.15.994,15.84,15.84,0,0,1-11.2-19.375l4.74-1.5.731-4.845L5.47,4.872A15.755,15.755,0,0,1,20.56,1.045l-1.548,2.71L22.176,4.93,22.9,7.636l-6.547.239L11.6,8.955l.4,4.23,6.332-.1.154-2.365,3.233,1.449-.591,2.693,1.975.694,2.368-1.9.919,1.022L22.771,17.1l-3.619-2.409-9.2-.178.1,4.815,2.911,1.722,4.77,1.989.574,4.593,3.328,2.546,6.205-10.241.185,3.185L30,24.746a16.023,16.023,0,0,1-7.179,6.277",
    transform: "translate(1.163 1.162)",
    fill: "#5ebae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21777",
    "data-name": "Path 21777",
    d: "M25.078,15.865a15.852,15.852,0,0,1-1.938,7.61l-1.613-1.322-.314-5.467-7.1,11.721-2.33-1.78L11.194,21.9l-5.16-2.146L3.567,18.292l-.068-3.5,8.1.157,3.872,2.58,4.866-3.243-2.074-2.307-2.621,2.095-.858-.3.577-2.635L10.443,8.929l-.181,2.792-4.811.072L5.187,9.035l3.978-.909,7.5-.267-1.1-4.114L12.91,2.757,14.078.714a15.968,15.968,0,0,1,11,15.151",
    transform: "translate(8.457 1.725)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21778",
    "data-name": "Path 21778",
    d: "M4.426,10.163A18.579,18.579,0,0,1,7.874,9.62a29.045,29.045,0,0,1,3.711.048,15.878,15.878,0,0,1-4.692.707,15.881,15.881,0,0,1-2.467-.212",
    transform: "translate(10.698 23.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21779",
    "data-name": "Path 21779",
    d: "M18.1,27.955A15.924,15.924,0,0,1,6.034,1.616,15.929,15.929,0,1,0,28.5,24.077,15.875,15.875,0,0,1,18.1,27.955",
    transform: "translate(1.163 3.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21780",
    "data-name": "Path 21780",
    d: "M4.322,1.937l.731.868-.6,3.971L.714,7.955A16,16,0,0,1,4.322,1.937",
    transform: "translate(1.726 4.681)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21781",
    "data-name": "Path 21781",
    d: "M17.591,0A17.59,17.59,0,1,0,35.179,17.591,17.61,17.61,0,0,0,17.591,0M33.536,17.591A15.823,15.823,0,0,1,31.6,25.2l-1.609-1.326-.318-5.464-7.1,11.717-2.327-1.78-.591-4.722-5.16-2.146-2.464-1.463-.072-3.5,8.105.154,3.872,2.58L28.8,16.006l-2.074-2.3L24.1,15.8l-.858-.3.574-2.631L18.9,10.651l-.181,2.792-4.815.072-.263-2.754,3.981-.909,7.5-.267-1.1-4.118-2.659-.984L22.536,2.44a15.964,15.964,0,0,1,11,15.151M6.048,6.619l.731.865-.6,3.971L2.443,12.633A15.933,15.933,0,0,1,6.048,6.619m9.076,26.7a18.869,18.869,0,0,1,3.448-.543,30.367,30.367,0,0,1,3.711.048,15.39,15.39,0,0,1-7.159.5m8.864-1.138a28.61,28.61,0,0,0-5.457-.226,21.85,21.85,0,0,0-5.15.994A15.84,15.84,0,0,1,2.177,13.58l4.74-1.5.731-4.845-1.015-1.2a15.755,15.755,0,0,1,15.09-3.827l-1.548,2.71,3.164,1.175L24.067,8.8l-6.547.239-4.76,1.08.4,4.23,6.332-.1.154-2.365,3.233,1.449-.591,2.693,1.975.694,2.368-1.9.919,1.022-3.615,2.412-3.619-2.409-9.2-.178.1,4.815,2.911,1.722L18.9,24.2l.574,4.593L22.8,31.338,29,21.1l.185,3.185,1.979,1.627a16.023,16.023,0,0,1-7.179,6.277",
    transform: "translate(0 -0.001)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImmersion);
export default __webpack_public_path__ + "static/media/ic_immersion.c1aceea40f11231b482c9165469fcf0d.svg";
export { ForwardRef as ReactComponent };